import React, { useEffect, useCallback, useState } from "react";
import Collapsible from "react-collapsible";
import { api } from "../../index.api";
import InputWithTick from "../../plugins/inputWithTickIcon";
import "./prod_styles.css";
import connect from "react-redux/es/connect/connect";
import { REF_DATA } from "../../../constants";
import { getApplicationRegex } from "../../plugins/utils";

const EditProductTable = (props) => {

  const [data, setData] = useState(props.data);
  const [isOpen, setIsOpen] = useState(
    Object.keys(props.data.local).reduce((acc, country) => {
      acc[country] = false;
      return acc;
    }, {})
  );

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const handleTriggerClick = useCallback((country) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [country]: !prevState[country],
    }));
  }, []);
  const updateDataState = (country, productCode, updates) => {
    setData((prevData) => {
      // Check if the productCode is available in the specified country's products
      const productExists = prevData.local[country].some(
        (product) => product && product.productCode === productCode
      );

      // If the product exists, update the product details
      if (productExists) {
        return {
          ...prevData,
          local: {
            ...prevData.local,
            [country]: prevData.local[country].map((product) =>
              product && product.productCode === productCode
                ? { ...product, ...updates }
                : product
            ),
          },
        };
      } else {
        // Return the original data if productCode is not found
        return {
          ...prevData,
          local: {
            ...prevData.local,
            [country]: [
              ...prevData.local[country],
              { productCode, ...updates },
            ],
          },
        };
      }
    });
  };

  const callApi = (country, productCode, updates) => {
    const payload = {
      productCode: productCode,
      countryName: country,
      localName: updates.localName,
      disable: updates.disable,
    };
    api.admin.localProduct.updateProductName(
      payload,
      (response) =>
        updateProductSuccessHandler(response, country, productCode, updates),
      (error) => updateProductFailureHandler(error)
    );
  };

  const regexValidation = (inputValue) => {
      const ref_Data = props.referenceData.find(function (category) {
        return category.type === REF_DATA;
      }).referenceData;
      const regex = getApplicationRegex(ref_Data);

      if (regex.Emoji_Regex !== null && regex.Emoji_Regex.test(inputValue)) {
        // Emoji detected, prevent it from being added
        props.notify(
          "Error!",
          "Special characters are not allowed",
          "error"
        );
        return;
      } else if (
        regex.Script_Regex !== null &&
        regex.Script_Regex.test(inputValue)
      ) {
        // HTML Tags and Script detected, prevent it from being added
        props.notify(
          "Error!",
          "Submission fails. Input contains prohibited words. Please remove them and try again.",
          "error"
        );
        return;
      } else if (regex.Script_Regex === null || regex.Emoji_Regex === null) {
        props.notify(
          "Error!",
          "Validation configuration is missing. Please contact support.",
          "error"
        );
        return;
      }
      return true;
  };

  const handleLocalNameUpdate = useCallback(
    ({ country, productCode, newValue }) => {
      const product =
        data.local[country].find((p) => p.productCode === productCode) || {};
      const disable = product.hasOwnProperty("disable")
        ? product.disable
        : false;
      //name validations
      const validated = regexValidation(newValue);
      if (validated) {
        callApi(country, productCode, {
          countryName: country,
          localName: newValue,
          disable: newValue === "" ? true : disable,
        });
      }
    },
    [data]
  );

  const handleCheckboxUpdate = useCallback(
    ({ country, productCode, newValue }) => {
      const product =
        data.local[country].find((p) => p.productCode === productCode) || {};
      const localName = product.localName || "";

      callApi(country, productCode, {
        countryName: country,
        localName: localName,
        disable: newValue,
      });
    },
    [data]
  );

  const updateProductSuccessHandler = (
    response,
    country,
    productCode,
    updates
  ) => {
    if (response.status === 200) {
      updateDataState(country, productCode, {
        countryName: country,
        localName: updates.localName,
        disable: updates.disable,
      });
      props.notify(
        "Success",
        `${productCode} Product updated successfully.`,
        "success"
      );
    } else if (response.status === 401) {
      props.notify(
        "Error",
        "You are not authorized to perform this action. Please log in again.",
        "error"
      );
      setTimeout(() => window.location.replace("/"), 3000);
    } else {
      props.notify(
        "Error",
        "There seems to be some error while updating product.",
        "error"
      );
    }
  };

  const updateProductFailureHandler = (error) => {
    props.notify(
      "Error",
      "There seems to be an error at our server side. Please try later.",
      "error"
    );
  };

  return (
    <div>
      {Object.keys(data.local).length > 0 &&
        Object.entries(data.local).map(([country, products], localIndex) => {
          return (
            <div key={country} className="editProducts">
              <Collapsible
                trigger={
                  <div
                    className={`Collapsible__trigger_header ${
                      isOpen[country] ? "Collapsible__trigger_open_header" : ""
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="18"
                      fill="currentColor"
                      className={`bi bi-chevron-down toggle-btn ${
                        isOpen[country] ? "open" : ""
                      }`}
                      viewBox="0 0 14 14"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                        stroke="currentColor"
                        stroke-width="2"
                      />
                    </svg>
                    <span>{country.toUpperCase()} PRODUCTS</span>
                  </div>
                }
                open={isOpen[country]}
                onTriggerOpening={() => handleTriggerClick(country)}
                onTriggerClosing={() => handleTriggerClick(country)}
              >
                <table className="editProductTable">
                  <thead className="editProductTable_header">
                    <tr>
                      <th>PRODUCT</th>
                      <th>PRODUCT CODE</th>
                      <th>VEEVA PRODUCT ID</th>
                      <th>LOCAL PRODUCT NAME</th>
                      <th>ENABLE FOR COUNTRY</th>
                    </tr>
                  </thead>
                  <tbody className="editProductTable_body">
                    {data.master.map((masterProduct, masterIndex) => {
                      const localProduct =
                        products.find(
                          (p) =>
                            p && p.productCode === masterProduct.productCode
                        ) || {};
                      return (
                        <tr key={masterProduct.id}>
                          <td className="editProductTable_masterDetails">
                            {masterProduct.name}
                          </td>
                          <td className="editProductTable_masterDetails">
                            {masterProduct.productCode}
                          </td>
                          <td className="editProductTable_masterDetails">
                            {masterProduct.veevaProductCode}
                          </td>
                          <td className="productEntry">
                            <InputWithTick
                              id={`localName_${localIndex}_${masterIndex}`}
                              defaultValue={localProduct.localName || ""}
                              onUpdateValue={(value) =>
                                handleLocalNameUpdate({
                                  country: country,
                                  productCode: masterProduct.productCode,
                                  newValue: value,
                                })
                              }
                            />
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <div className="edit-product-checkbox">
                              <input
                                id={`enable_${localIndex}_${masterIndex}`}
                                type="checkbox"
                                checked={!!localProduct.localName && !localProduct.disable}
                                disabled={!localProduct.localName}
                                name="localNameVisibility"
                                onChange={(e) =>
                                  handleCheckboxUpdate({
                                    country: country,
                                    productCode: masterProduct.productCode,
                                    newValue: !e.target.checked,
                                  })
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Collapsible>
            </div>
          );
        })}
    </div>
  );
};
const mapStateToProps = (state) => ({
  referenceData: state.referenceData,
});
export default connect(mapStateToProps)(EditProductTable);



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Product_Mangement/EditProductTable.js